
import {BrowserModule} from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {AppComponent} from './app.component';
import {FirebaseModule} from './firebase/firebase.module';
import {IssueEquipmentComponent} from './issue-equipment/issue-equipment.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {EmployeeListComponent} from './employee-list/employee-list.component';
import {EquipmentListComponent} from './equipment-list/equipment-list.component';
import {AppRoutingModule} from './app-routing.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FlexLayoutModule} from '@angular/flex-layout';
import {SignaturePadModule} from 'ngx-signaturepad';
import {AuthGuard} from './auth.guard';
import {WelcomeComponent} from './welcome-component/welcome.component';
import {MaterialModule} from './material.module';

@NgModule({
  declarations: [
    AppComponent,
    IssueEquipmentComponent,
    EmployeeListComponent,
    EquipmentListComponent,
    IssueEquipmentComponent,
    WelcomeComponent,
  ],
  entryComponents: [
    IssueEquipmentComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    FirebaseModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    FormsModule,
    SignaturePadModule,
    MaterialModule,
  ],
  providers: [AuthGuard],
  bootstrap: [AppComponent]
})
export class AppModule {
}
